(function ($) {
  $(document).ready(function () {
    var $form = $('.form-wrapper');
    if (!$form.length) {
      return;
    }

    $form.validate({
      rules: {
        'customer[first_name]': {
          required: true,
          minlength: 2,
        },
        'customer[last_name]': {
          required: true,
          minlength: 2,
        },
        'customer[email]': {
          required: true,
          email: true,
        },
        'customer[password]': {
          required: true,
        },
        'contact[name]': {
          required: true,
        },
        'contact[email]': {
          required: true,
          email: true,
        },
      },
    });
  });
})(jQuery);
